import { provideHttpClient, withFetch } from "@angular/common/http";
import { APP_INITIALIZER, ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { DomSanitizer } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from "@angular/material/core";
import { MatIconRegistry } from "@angular/material/icon";
import { provideTransloco, provideTranslocoLang, TranslocoService } from "@jsverse/transloco";

import { authReadyFactory } from "./auth/auth-ready.factory";
import { AuthService } from "./auth/auth.service";
import { provideFirebase } from "./firebase/firebase.providers";
import { routes } from "./app.routes";
import { TranslocoHttpLoader } from "./i18n/transloco-http.loader";
import { translocoPreloadLangFactory } from "./i18n/transloco-preload.factory";
import { registerAppSvgIconsFactory } from "./register-app-svg-icons.factory";

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideFirebase(),
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: authReadyFactory,
            deps: [AuthService]
        },
        provideRouter(routes),
        provideHttpClient(withFetch()),
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: "fr-CA" },
        provideTransloco({
            config: {
                availableLangs: ["fr"],
                defaultLang: "fr",
                reRenderOnLangChange: true,
                prodMode: !isDevMode()
            },
            loader: TranslocoHttpLoader
        }),
        provideTranslocoLang("fr"),
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: translocoPreloadLangFactory,
            deps: [TranslocoService]
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: registerAppSvgIconsFactory,
            deps: [MatIconRegistry, DomSanitizer]
        }
    ]
};
